export function forget (promise: Promise<unknown>) {
  Promise.resolve()
    .then(() => promise)
    .then(() => {
      //
    }).catch(() => {
      //
    })
}